import { ForwardBtn, ProjectCard } from "@components/shared";
import { homePortfolioSectionData } from "@demo-data/portfolio";
import { Stack } from "@mui/system";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function Portfolio() {
  return (
    <Stack gap={4}>
      <ForwardBtn title="Portfolio" href="/portfolio" />
      <ProjectCard data={homePortfolioSectionData} />
    </Stack>
  );
}
